import React from 'react';
import FocusLock from 'react-focus-lock';
export const FocusTrap = ({ shards, disabled, children, allowClickOutside = true, returnFocus = true, }) => {
    const [disableTrap, setDisableTrap] = React.useState(disabled);
    const focusLockRef = React.useRef(null);
    function checkFocusElementContains(target) {
        const shardArray = shards ? [focusLockRef, ...shards] : [focusLockRef];
        const isTargetShardArray = shardArray.some((element) => {
            if (element === null || element === void 0 ? void 0 : element.current.contains(target))
                return true;
            return false;
        });
        if (isTargetShardArray) {
            setDisableTrap(false);
            return;
        }
        setDisableTrap(true);
    }
    /**
     * When focusTrap is not disabled and allowClickOutside is true,
     * - disable focusTrap when outside focusable element is clicked
     * - restore focusTrap when focusTrap element is clicked
     */
    React.useEffect(() => {
        function handleClickOutside(event) {
            var _a, _b;
            checkFocusElementContains((_b = (_a = event.composedPath) === null || _a === void 0 ? void 0 : _a.call(event)[0]) !== null && _b !== void 0 ? _b : event.target);
        }
        if (disabled || !allowClickOutside)
            return;
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [disabled, allowClickOutside]);
    /**
     * When focusTrap is not disabled,
     * restore focusTrap when focusTrap element gets focus
     */
    React.useEffect(() => {
        setDisableTrap(disabled);
        function handleKeyboardFocus() {
            checkFocusElementContains(document.activeElement);
        }
        if (disabled)
            return;
        document.addEventListener('keydown', handleKeyboardFocus);
        return () => document.removeEventListener('keydown', handleKeyboardFocus);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [disabled]);
    return (React.createElement(FocusLock, { shards: shards, disabled: disableTrap, ref: focusLockRef, crossFrame: false, returnFocus: returnFocus }, children));
};
//# sourceMappingURL=FocusTrap.js.map